
import { getDeploymentTicketsStatus, getTopOutstandingDomains, getUpcomingRenewals, 
        getSupportTicketsStatus } from "../../../http/CentralizedDataHttp";
import GetSupportTicketModal from "../../../components/Centralized/GetSupportTicketModal";
import DomainDetailModal from "../../../components/Centralized/DomainDetailModal";
import GetDeploymentTicketModal from "../../../components/Centralized/GetDeploymentTicketModal";
import Div from "../../../components/Div"
import Input from "../../../components/Input";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import the plugin
import { Pie, Bar } from "react-chartjs-2"; // Import Pie chart
import { Chart, ArcElement, Tooltip, Legend, Title, LinearScale, CategoryScale, BarElement } from "chart.js";
import RenewalTeam from "../../../components/Dashboards/RenewalTeam"
import { useState, useEffect } from "react"

Chart.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    LinearScale,
    CategoryScale,
    BarElement
    // ChartDataLabels // Register the datalabels plugin if you're using it
);


export default function RenewalDashboard() {

    const [toggleView, setToggleView] = useState("Graph View"); // Toggle state

    const handleToggleView = () => {
        setToggleView(toggleView === "Graph View" ? "Table View" : "Graph View"); // Toggle between graph and table
    };

    const [teamDomain, setTeamDomain] = useState(false);
    const [upcomingDomain, setUpcomingDomain] = useState(false);
    const [totalCaseCount, setTotalCaseCount] = useState(null);
    const [supportCaseCount, setSupportCaseCount] = useState(null);
    const [barOnClick, setBarOnClick] = useState(false);
    const [deploymentTicket, setDeploymentTicket] = useState(false);
    const [supportTicket, setSupportTicket] = useState(false);



    const getTeamData = async () => {
        try {
            const response = await getTopOutstandingDomains()
            // console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}> Domains</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Outstanding Amount </th>
            </>

            setTeamDomain({
                data: response.domains,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    }

    const getUpcomingRenewalDomains = async () => {
        try {
            // const response = await getUpcomingRenewals()
            // // console.log(response)

            // const columns = <> <th style={{
            //     position: "sticky",
            //     top: 0,
            //     backgroundColor: "#f1f1f1",
            //     zIndex: 100,
            // }}> Domains</th>
            //     <th style={{
            //         position: "sticky",
            //         top: 0,
            //         backgroundColor: "#f1f1f1",
            //         zIndex: 100,
            //     }}>License</th>
            // </>

            // setUpcomingDomain({
            //     data: response.domains,
            //     columns: columns
            // });

        } catch (error) {
            console.log(error)
        }
    }

    const getDeploymentTicketStatus = async () => {
        try {
            const response = await getDeploymentTicketsStatus()
            // console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}> Domains</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Ticket Status</th>
            </>


            setTotalCaseCount({
                data: response.tickets,
                columns: columns
            })


        } catch (error) {
            console.log(error)
        }
    }

    const getSupportTicketStatus = async () => {
        try {
            const response = await getSupportTicketsStatus()
            // console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}> Domains</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Ticket Status</th>
            </>


            setSupportCaseCount({
                data: response.tickets,
                columns: columns
            })


        } catch (error) {
            console.log(error)
        }
    }




    useEffect(() => {

        getTeamData()
        getUpcomingRenewalDomains()
        getDeploymentTicketStatus()
        getSupportTicketStatus()

    }, []);

    const customerChartData = {

        labels: teamDomain?.data
            ? teamDomain.data.map(
                (entry) => Object.values(entry)[0]
            )
            : [], // Get the years or an empty array if null
        datasets: [
            {
                label: "Top Outstanding Amount in Cr",
                data: teamDomain ? teamDomain.data.map(
                    (entry) => Object.values(entry)[1]
                )
                    : [], // Get the number of customers or an empty array if null
                backgroundColor: "rgba(255, 50, 50, 0.5)",
                borderColor: "rgba(255, 192, 192, 1)",
                borderWidth: 1,
            },
        ],
    };

    const renewalChartData = {
        labels: upcomingDomain?.data
            ? upcomingDomain.data.map(
                (entry) => Object.values(entry)[0]
            )
            : [], // Get the years or an empty array if null
        datasets: [
            {
                label: "Top Renewals this month",
                data: upcomingDomain ? upcomingDomain.data.map(
                    (entry) => Object.values(entry)[1]
                )
                    : [], // Get the number of customers or an empty array if null
                backgroundColor: "rgba(75, 192, 192, 0.6)",
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 1,
            },
        ],
    }

    const totalCasesData = {
        labels: ["Open", "Closed"],
        datasets: [
            {
                data: [
                    // totalCaseCount ? totalCaseCount.data[2]?.count : 0,
                    totalCaseCount ? totalCaseCount.data[1]?.count : 0,
                    totalCaseCount ? totalCaseCount.data[0]?.count : 0
                ],
                backgroundColor: [
                    // "rgba(75, 192, 192, 0.6)", // Open cases color
                    "rgba(153, 102, 255, 0.6)", // Closed cases color
                    "rgba(255, 159, 64, 0.6)", // Pending cases color
                ],
                hoverBackgroundColor: [
                    // "rgba(75, 192, 192, 0.8)",
                    "rgba(153, 102, 255, 0.8)",
                    "rgba(255, 159, 64, 0.8)",
                ],
            },
        ],
    };

    const SupportCasesData= {
        labels: supportCaseCount ? supportCaseCount.data.map((data)=> data.status) : 0,
        datasets: [
            {
                data: supportCaseCount ? supportCaseCount.data.map((db)=> db.count) : 0,
                    
                // [
                //     supportCaseCount ? supportCaseCount.data.map((db)=> db.count) : 0,
                //     // supportCaseCount ? supportCaseCount.data[1]?.count : 0,
                //     // supportCaseCount ? supportCaseCount.data[0]?.count : 0
                // ],
                backgroundColor: [
                    "rgba(75, 192, 192, 0.6)", // Open cases color
                    "rgba(153, 102, 255, 0.6)", // Closed cases color
                    "rgba(255, 159, 64, 0.6)", // Pending cases color
                    "rgba(200, 159, 100, 0.6)", // Pending cases color
                    "rgba(150, 200, 150, 0.6)", // Pending cases color
                    "rgba(100, 159, 175, 0.6)", // Pending cases color
                    "rgba(50, 100,200, 0.6)", // Pending cases color
                    "rgba(0, 50, 255, 0.6)", // Pending cases color
                    "rgba(0, 0, 50, 0.6)", // Pending cases color
                    "rgba(0, 0, 100, 0.6)", // Pending cases color
                ],
                hoverBackgroundColor: [
                    "rgba(75, 192, 192, 0.8)",
                    "rgba(153, 102, 255, 0.8)",
                    "rgba(255, 159, 64, 0.8)",
                    "rgba(200, 159, 100, 0.6)", // Pending cases color
                    "rgba(150, 200, 150, 0.6)", // Pending cases color
                    "rgba(100, 159, 175, 0.6)", // Pending cases color
                    "rgba(50, 100,200, 0.6)", // Pending cases color
                    "rgba(0, 50, 255, 0.6)", // Pending cases color
                    "rgba(0, 0, 50, 0.6)", // Pending cases color
                    "rgba(0, 0, 100, 0.6)", // Pending cases color
                ],
            },
        ],

    }

    const chartOptions = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    const pieChartOptions = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "right",
                align: "start",
                labels: {
                    boxWidth: 12,
                    padding: 20,
                },
            },
            // Custom plugin to display values on the chart
            datalabels: {
                formatter: (value, context) => {
                    // Only show the label if the value is greater than 0
                    return value > 0 ? `${value}` : "";
                },
                color: "#000000", // Change the color of the labels if needed
            },
        },
    };


    const handleChartClick = async (chartName, e) => {
        const chart = e.chart;
        const elements = chart.getElementsAtEventForMode(
            e,
            "nearest",
            { intersect: true },
            false
        );

        if (elements.length) {
            const index = elements[0].index;
            const label = chart.data.labels[index];


            // API calls based on chart name
            switch (chartName) {
                case "outstanding":
                    // Fetching dashboard data based on chart name
                    try {
                        setBarOnClick(label)

                    } catch (error) {
                        console.error("Error fetching dashboard data:", error);
                    }
                    break;
                case "renewal":
                    try {
                        setBarOnClick(label)

                    } catch (error) {
                        console.error("Error fetching dashboard data:", error);
                    }
                    break;
                case "deployment_ticket":
                    try {
                        setDeploymentTicket(label)

                    } catch (error) {
                        console.error("Error fetching dashboard data:", error);
                    }
                    break;
                case 'support_ticket':
                    try {
                        setSupportTicket(label)

                    } catch (error) {
                        console.error("Error fetching dashboard data:", error);
                    }
                    break;
                default:
                    console.log("No specific API call for this chart.");
                    break;
            }
        }
    };


    const toggleButtonStyles = {
        toggleContainer: {
            display: "flex",
            alignItems: "center",
            gap: "10px",
        },
        switch: {
            position: "relative",
            display: "inline-block",
            width: "60px",
            height: "34px",
        },
        slider: {
            position: "absolute",
            cursor: "pointer",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            backgroundColor: "#ccc",
            transition: "0.4s",
            borderRadius: "34px",
        },
        sliderChecked: {
            backgroundColor: "#4CAF50", // Green when ON
        },
        sliderButton: {
            position: "absolute",
            content: '""',
            height: "26px",
            width: "26px",
            borderRadius: "50%",
            left: "4px",
            bottom: "4px",
            backgroundColor: "white",
            transition: "0.4s",
        },
        sliderButtonChecked: {
            transform: "translateX(26px)", // Move to the right when checked
        },
    };

    const chartStyle = {
        width: "50%", // Ensure each chart takes up 48% of the container width
        height: "520px",
        border: "1px solid #ddd", // Add border to the chart
        borderRadius: "10px", // Rounded corners for the chart
        padding: "15px", // Padding inside the chart container
        backgroundColor: "#fff", // Background color for better visibility
    };

    return <>
        <Div className='row'>
            <Div style={toggleButtonStyles.toggleContainer} >

                <label style={toggleButtonStyles.switch}>

                    <Input type="checkbox"
                        style={{ display: "none" }}
                        checked={toggleView === "Graph View"} // Checked if it's Graph View
                        onChange={handleToggleView} // Handle toggle click
                    />
                    <span
                        style={{
                            ...toggleButtonStyles.slider,
                            ...(toggleView === "Graph View"
                                ? toggleButtonStyles.sliderChecked
                                : {}),
                        }}
                    >

                    </span>
                    <span
                        style={{
                            ...toggleButtonStyles.sliderButton,
                            ...(toggleView === "Graph View"
                                ? toggleButtonStyles.sliderButtonChecked
                                : {}),
                        }}
                    ></span>
                </label>
                <span>{toggleView}</span>
            </Div>
                     
            {barOnClick ? <DomainDetailModal show={true.toString()} open
            domain_name={barOnClick} handleClicked={setBarOnClick} /> : null}

            {deploymentTicket ? <GetDeploymentTicketModal show={true.toString()} open
            domain_name={deploymentTicket} handleClicked={setDeploymentTicket} /> : null}

            {supportTicket ? <GetSupportTicketModal show={true.toString()} open
            domain_name={supportTicket} handleClicked={setSupportTicket} /> : null}

            <Div className='row justify-content-center' style={{ marginTop: '25px', marginLeft: '25px' }}>
                {toggleView === "Graph View" ?
                    <>
                        <Div className='col-5' style={chartStyle}>
                            <strong>Top 5 Outstanding Amount in Cr</strong>
                            <Bar
                                data={customerChartData}
                                options={{
                                    ...chartOptions,
                                    onClick: (e) =>
                                        handleChartClick("outstanding", e),
                                }}
                            />
                        </Div>
                    </>
                    : <Div className='col-5' style={chartStyle}>
                        <RenewalTeam title='Most 5 Outstanding Amount in Cr'
                            data={teamDomain.data} columns={teamDomain.columns}
                            tag='centralized' />
                    </Div>}

                <Div className='col-1'>
                </Div>

                {toggleView === "Graph View" ?
                    <>
                        <Div className='col-5' style={chartStyle}>
                            <strong>Top 5 Renewal this Month</strong>
                            <Bar
                                data={renewalChartData}
                                options={{
                                    ...chartOptions,
                                    onClick: (e) =>
                                        handleChartClick("renewal", e),
                                }}
                            />
                        </Div>
                    </>
                    :
                    <Div className='col-5' style={chartStyle}>
                        <RenewalTeam title='Top 5 Renewals This Month'
                            data={upcomingDomain.data} columns={upcomingDomain.columns}
                            tag='centralized' />
                    </Div>
                }
            </Div>

            <Div className='row justify-content-center' style={{ marginTop: '25px', marginLeft: '25px' }}>
                {toggleView === "Graph View" ?
                    <>
                        <Div className='col-5' style={chartStyle}>
                            {/* <strong>Deployment Ticket Status</strong> */}
                            <Pie
                                data={totalCasesData}
                                options={{
                                    ...pieChartOptions,
                                    onClick: (e) => handleChartClick("deployment_ticket", e),
                                }}
                                plugins={[ChartDataLabels]}
                            />
                        </Div>
                        <Div className='col-1'></Div>

                        <Div className='col-5' style={chartStyle}>
                            <strong>Support Ticket Status</strong>
                            <Pie
                                data={SupportCasesData}
                                options={{
                                    ...pieChartOptions,
                                    onClick: (e) => handleChartClick("support_ticket", e),
                                }}
                                plugins={[ChartDataLabels]}
                            />
                        </Div>
                    </>
                    :
                    <>
                     <Div className='col-5' style={chartStyle}>
                        <RenewalTeam title='Deployment Ticket Status'
                            data={totalCaseCount.data} columns={totalCaseCount.columns}
                            tag='deployment_ticket' />
                    </Div>

                    <Div className='col-1'></Div>


                    <Div className='col-5' style={chartStyle}>
                        <RenewalTeam title='Support Ticket Status'
                            data={supportCaseCount.data} columns={supportCaseCount.columns}
                            tag='support_ticket' />
                    </Div>
                    </>
                    
                    }
            </Div>
        </Div>
    </>
}